import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const SummaryBlock = makeShortcode("SummaryBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "distribution-options"
    }}>{`Distribution Options`}</h1>
    <p>{`Once you have a packaged your code correctly, you're ready to distribute it.`}</p>
    <h2 {...{
      "id": "distributing-scripts"
    }}>{`Distributing scripts`}</h2>
    <p>{`A UXP script can be directly shared. Just share your `}<inlineCode parentName="p">{`.idjs`}</inlineCode>{` file with your family and friends and they can run it after importing it within the Scripts panel.`}</p>
    <h2 {...{
      "id": "distributing-plugins"
    }}>{`Distributing plugins`}</h2>
    <p>{`While sharing your plugins, you have a couple of options:`}</p>
    <SummaryBlock slots="heading, text, buttons" background="rgb(141, 52, 78)" mdxType="SummaryBlock" />
    <h3 {...{
      "id": "distribute-on-creative-cloud-plugin-marketplace"
    }}>{`Distribute on Creative Cloud Plugin Marketplace`}</h3>
    <p>{`Use the Developer Distribution portal to submit your plugin to the Plugin Marketplace to reach a large number of users.
Users can download your plugin directly in the Creative Cloud desktop app.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/developer-distribution/creative-cloud/docs/guides/"
        }}>{`Developer Distribution Documentation`}</a></li>
    </ul>
    <h3 {...{
      "id": "direct-distribution-with-ccx-files"
    }}>{`Direct distribution with `}<inlineCode parentName="h3">{`.ccx`}</inlineCode>{` files`}</h3>
    <p>{`Give the plugin to your family, friends, and workmates. You can email the `}<inlineCode parentName="p">{`.ccx`}</inlineCode>{` file or, more likely, put it on a cloud folder somewhere for them to download. All they need to do is double-click the `}<inlineCode parentName="p">{`.ccx`}</inlineCode>{` file to install using the Creative Cloud application. It's that easy! Be aware that distributing this way will require them to click through the "Do you trust this?" warning dialog boxes that appear after they double-click.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      